import styled from "@emotion/styled";

export const HeaderWrapper = styled('header')(() => ({
  width: "100%",
  backgroundColor: "#EDF5FB",
  padding: "1.25rem 1.875rem",
  height: 90,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  "@media screen and (max-width: 435px)": {
    padding: "1rem"
  }
}))

export const ImageLogo = styled('img')(() => ({
  width: 185,
  "@media screen and (max-width: 435px)": {
    width: 143,
  }
}))
